<template>
  <div>
    <ExportPdf :id="$route.query.id" />
    <MasterLayout>
      <div class="py-4 dashboard_first_row">
        <div class="invoice_edit_del_cont">
          <!-- <div>
            <router-link
              :to="
                $route.name == 'branch_invoice_details'
                  ? {
                      name: 'branch_invoice_payments',
                      query: $route.query.branchId
                        ? {
                            id: $route.query.id,
                            branchId: $route.query.branchId,
                          }
                        : { id: $route.query.id },
                    }
                  : { name: 'invoice_payments', query: { id: $route.query.id } }
              "
              class="invoice_btn edit_invoice"
              >{{ $t("text.bInvoices.invoicePayments") }}</router-link
            >
            <button class="invoice_btn" @click="downloadPdf">
              {{ $t("text.actionButtons.exportPdf") }}
            </button>
          </div> -->
        </div>
        <div class="dialog-container" style="width: 80%">
          <div class="row">
            <div class="col-md-6">
              <div class="row align-items-center">
                <div class="col-md-3">
                  <div>
                    <span>{{ $t("text.bInvoices.status") }}</span>
                  </div>
                  <div>
                    <div
                      class="invoice-status bold-span overdue"
                      :class="[
                        invoiceDetails.status === 'OverDue'
                          ? 'danger'
                          : invoiceDetails.status === 'Draft'
                          ? 'success'
                          : invoiceDetails.status === 'Paid'
                          ? 'paidColor'
                          : 'yelloInvoiceColor',
                      ]"
                    >
                      {{ invoiceDetails.status }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div>
                    <span>{{ $t("text.bSales.customer") }}</span>
                  </div>
                  <div>
                    <span class="bold-span">{{
                      invoiceDetails.customerName
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 text-right">
              <div class="row align-items-center">
                <div class="col-md-6">
                  <div>
                    <span>{{ $t("text.bInvoices.amountDue") }}</span>
                  </div>
                  <div>
                    <span class="bold-span"
                      >({{ branch ? branch.currencyCode : "" }})</span
                    ><span class="bold-span">{{
                      convertThousand(invoiceDetails.amountDue)
                    }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div>
                    <span class="">{{ $t("text.bInvoices.dateTemp") }}</span>
                  </div>
                  <div>
                    <span class="bold-span">{{
                      timeSince(new Date(invoiceDetails.invoiceDueDate))
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="preview-container mt-3">
              <div class="row ivoice-preview-header-wrapper pb-4">
                <div class="col-md-12 text-right">
                  <div class="e-heading--title pt-3 pr-3">
                    {{ invoiceDetails.invoiceTitle }}
                  </div>
                  <div class="e-heading--subtitle pr-3">
                    <h5 class="bold-span">
                      {{ invoiceDetails.invoiceDescription }}
                    </h5>
                  </div>
                  <div class="e-heading--subtitle pr-3">
                    {{ $t("text.general.company") }}
                  </div>
                  <div class="e-heading--para pt-2 pr-3">
                    {{ $t("text.general.country") }}
                  </div>
                </div>
              </div>
              <div class="row justify-content-space-between">
                <div class="col-md-7">
                  <div
                    class="invoice_customer p-3"
                    v-if="invoiceDetails.customerName"
                  >
                    <div class="bold-span grey-text">
                      {{ $t("text.bInvoices.billTo") }}
                    </div>
                    <div class="bold-span mt-1">
                      {{ invoiceDetails.customerName }}
                    </div>
                    <div class="bold-span mt-1">
                      {{ invoiceDetails.customerMail }}
                    </div>
                  </div>
                  <!-- <div class="invoice_customer p-5" v-if="!invoiceDetails.customerName">
                                        You have not added a customer
                                    </div> -->
                </div>
                <div class="col-md-5">
                  <div class="row align-items-center pt-3">
                    <div class="col-md-5 text-right">
                      <label class="primary-color"
                        >{{ $t("text.bInvoices.invoiceNo") }}
                      </label>
                    </div>
                    <div class="col-md-7">
                      <div class="">
                        {{ invoiceDetails.invoiceNumber }}
                      </div>
                    </div>
                  </div>
                  <div class="row align-items-center mt-1">
                    <div class="col-md-5 text-right">
                      <label class="primary-color">{{
                        $t("text.bInvoices.invoiceDate")
                      }}</label>
                    </div>
                    <div class="col-md-7">
                      <div class="">
                        <small class="bold-span">{{
                          $moment(invoiceDetails.invoiceDate).format(
                            "DD MMMM YYYY",
                          )
                        }}</small>
                      </div>
                    </div>
                  </div>
                  <div class="row align-items-center mt-1">
                    <div class="col-md-5 text-right">
                      <label class="primary-color"
                        >{{ $t("text.bInvoices.paymentDue") }}
                      </label>
                    </div>
                    <div class="col-md-7">
                      <div class="">
                        <small class="bold-span">{{
                          $moment(invoiceDetails.invoiceDueDate).format(
                            "DD MMMM YYYY",
                          )
                        }}</small>
                      </div>
                    </div>
                  </div>
                  <div class="row align-items-center mt-1">
                    <div class="col-md-5 text-right">
                      <label class="primary-color">{{
                        $t("text.bInvoices.amountDue")
                      }}</label>
                    </div>
                    <div class="col-md-7">
                      <div class="bold-span">
                        ₦ {{ convertThousand(invoiceDetails.amountDue) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="preview-table header p-2 mt-2 pl-3 pr-3">
                <div class="invoice_item_name">
                  <span class="text-white">{{
                    $t("text.bInvoices.items")
                  }}</span>
                </div>
                <div class="invoice_item_quantity">
                  <span class="text-white"
                    >{{ $t("text.bInvoices.qty") }}y</span
                  >
                </div>
                <div class="invoice_item_price">
                  <span class="text-white">{{
                    $t("text.bInvoices.price")
                  }}</span>
                </div>
                <div class="text-right invoice_item_total">
                  <span class="text-white">{{ $t("text.bInvoices.amt") }}</span>
                </div>
              </div>
              <div
                v-if="
                  invoiceDetails.invoiceItems &&
                  invoiceDetails.invoiceItems.length
                "
              >
                <div
                  class="mt-2"
                  v-for="(prod, i) in invoiceDetails.invoiceItems"
                  :key="i"
                >
                  <div class="preview-table p-2 pl-3 pr-3">
                    <div class="invoice_item_name">
                      <span class="primary-color">{{ prod.itemName }}</span>
                      <span class="item_description">{{
                        prod.itemDescription
                      }}</span>
                    </div>
                    <div class="invoice_item_quantity">
                      <span class="primary-color">{{ prod.itemQuantity }}</span>
                    </div>
                    <div class="invoice_item_price">
                      <span class=""
                        >₦{{ convertThousand(prod.itemPrice) }}</span
                      >
                    </div>
                    <div class="invoice_item_total">
                      <span class=""
                        >({{ branch ? branch.currencyCode : "" }})
                        {{
                          convertThousand(prod.itemPrice * prod.itemQuantity)
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="mt-2 text-center font-italic p-3"
                v-if="
                  invoiceDetails.invoiceItems &&
                  !invoiceDetails.invoiceItems.length
                "
              >
                {{ $t("text.bInvoices.noAddedItems") }}
              </div>
              <div class="text-right mt-3 pr-3">
                <span class="primary-color mr-3"
                  >{{ $t("text.bInvoices.subTot") }}
                </span>
                <span class="primary-color"
                  >{{ branch ? branch.currencyCode : "" }}
                  {{ convertThousand(subTotalInvoiceItemsPrice) }}</span
                >
              </div>
              <div
                class="text-right mt-3 pr-3"
                v-for="(value, name, i) in taxObj"
                :key="i"
              >
                <small class="mr-3"
                  >{{ value.name }}({{ value.rate }}%):
                </small>
                <small class=" "
                  >{{ branch ? branch.currencyCode : "" }}
                  {{ convertThousand(value.totalAmount) }}
                </small>
              </div>
              <div class="text-right mt-2 pr-3">
                <span class="primary-color mr-3">Total: </span>
                <span class="primary-color"
                  >{{ branch ? branch.currencyCode : "" }}
                  {{
                    convertThousand(subTotalInvoiceItemsPrice + taxAmount)
                  }}</span
                >
              </div>
              <div class="text-right mt-2 pr-3">
                <span class="primary-color mr-3"
                  >{{ $t("text.bInvoices.amtPaid") }}
                </span>
                <span class="primary-color"
                  >{{ branch ? branch.currencyCode : "" }}
                  {{ convertThousand(amountPaid) }}</span
                >
              </div>
              <hr />
              <div class="text-right mt-2 pr-3">
                <span class="primary-color mr-3 bold-span">{{
                  $t("text.bInvoices.amountDue")
                }}</span>
                <span class="primary-color bold-span"
                  >{{ branch ? branch.currencyCode : "" }}
                  {{ convertThousand(invoiceDetails.amountDue) }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </MasterLayout>
  </div>
</template>
<script>
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import ExportPdf from "@/components/modals/Invoices/exportPdf";
import configObject from "@/config";

import Jquery from "jquery";
let $ = Jquery;

export default {
  components: {
    MasterLayout,
    ExportPdf,
  },
  data() {
    return {
      invoiceItems: [],
      invoiceDetails: {},
      subTotalInvoiceItemsPrice: 0,
      taxAmount: 0,
      taxObj: {},
      amountPaid: 0,
    };
  },
  created() {
    this.getInvoiceDetails();
  },
  methods: {
    getInvoiceDetails() {
      if (!this.$route.query.id) {
        this.$toast.open({
          message: this.$t("text.bInvoices.noInvoiceSelected"),
          type: "error",
          duration: 5000,
        });
        // this.$router.push({
        //   name: "branch_invoice",
        //   query: this.$route.query.branchId
        //     ? { branchId: this.$route.query.branchId }
        //     : null,
        // });
        return;
      }
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Invoices/${this.$route.query.id}`,
          configObject.authConfig(),
        )
        .then((res) => {
          res.data.status =
            res.data.status == 0
              ? "Draft"
              : res.data.status == 1
              ? "Pending"
              : res.data.status == 2
              ? "Unsent"
              : res.data.status == 3
              ? "OverDue"
              : res.data.status == 4
              ? "Paid"
              : res.data.status == 5
              ? "PartPaid"
              : "Not available";
          this.invoiceDetails = res.data;
          this.subTotalInvoiceItemsPrice = res.data.invoiceItems.reduce(
            (total, cur) => {
              return total + cur.itemPrice * cur.itemQuantity;
            },
            0,
          );

          this.amountPaid = res.data.paymentDetails.reduce((total, cur) => {
            return total + cur.amountPaid;
          }, 0);

          let totalTax = 0;
          let invoiceObj = {};

          res.data.invoiceItems.forEach((cur) => {
            const totalPrice = cur.itemPrice * cur.itemQuantity;

            cur.invoiceTaxes.forEach((tax) => {
              totalTax += (tax.rate / 100) * totalPrice;
              const taxId = tax.taxId;
              if (invoiceObj[taxId]) {
                invoiceObj[taxId]["totalAmount"] =
                  invoiceObj[taxId]["totalAmount"] +
                  (tax.rate / 100) * totalPrice;
              } else {
                invoiceObj[taxId] = {
                  name: tax.taxName,
                  rate: tax.rate,
                  totalAmount: (tax.rate / 100) * totalPrice,
                };
              }
            });
          });

          this.taxAmount = totalTax;
          this.taxObj = invoiceObj;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.statusDescription,
            type: "error",
            duration: 5000,
          });
          // this.$router.push({
          //   name: "branch_invoice",
          //   query: this.$route.query.branchId
          //     ? { branchId: this.$route.query.branchId }
          //     : null,
          // });
        });
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    downloadPdf() {
      this.$modal.show("exportPdf");
    },

    timeSince(date) {
      let seconds = Math.floor((new Date() - date) / 1000);
      const value = seconds < 0 ? "from now" : "ago";
      seconds = Math.abs(seconds);

      var interval = seconds / 31536000;

      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " year " : " years ") +
          value
        );
      }
      interval = seconds / 2592000;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " month " : " months ") +
          value
        );
      }
      interval = seconds / 86400;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " day " : " days ") +
          value
        );
      }
      interval = seconds / 3600;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " hour " : " hours ") +
          value
        );
      }
      interval = seconds / 60;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " minute " : " minutes ") +
          value
        );
      }
      return (
        Math.floor(seconds) +
        (Math.floor(interval) == 1 ? " second " : " seconds ") +
        value
      );
    },
  },
};
</script>
